<script lang="ts" setup>
import { formatValue } from '@forgd/formatter'
import { KpiStat } from '@forgd/ui-kit/blocks/kpi-stat'

const props = defineProps<{
  loading?: boolean
  projectTicker?: string | null
  volume24h: number | null
  depth2Pct: number | null
}>()

const volumeLabel = computed(() => (props.volume24h != null ? formatValue(props.volume24h, 'currency') : 'Not Available'))
const depthLabel = computed(() => (props.depth2Pct != null ? formatValue(props.depth2Pct, 'currency:short') : 'Not Available'))
</script>

<template>
  <KpiStat
    size="sm"
    :loading="loading"
    :title="projectTicker ? `${projectTicker} 24h Volume (USD)` : '24h Volume (USD)'"
    :value="volumeLabel"
    description="Depth ± 2.00%"
    :meta="depthLabel"
  >
    <template #icon>
      <i class="i-lucide-chart-column size-4 text-primal" />
    </template>
  </KpiStat>
</template>
